import React from 'react';
import { BREAKPOINTS } from 'constants/breakpoints';
import useWindowSize from 'hooks/useWindowSize';
import IntegrationStackedContent from 'components/Integrations/Shared/IntegrationStackedContent';
import ProductSelectorContainer from 'components/Shared/ProductJourneySelector';
// Todo: get rid of this ASAP. This is used to block products that are not ready for Midsona but published in their account
const BLOCKED_MIDSONA_PRODUCTS = [
    'ff780c57-41d7-4f6e-a91a-e0581d49dbe2',
    '10432b91-cae9-4168-9cb6-431f30931ef8',
    'adf9e1be-0528-4f87-bd0c-fc1f35173919',
    'f1df3ea8-1a08-4d96-8464-20f2b3cff838',
    '553289cc-62c9-4929-8772-d3ab4b3830f3',
];
const ProductSliderIntegration = ({ products, locale }) => {
    const { width } = useWindowSize();
    const isMobile = width <= BREAKPOINTS.mobile;
    const filteredProducts = products.filter((product) => !BLOCKED_MIDSONA_PRODUCTS.includes(product.id));
    return (React.createElement(IntegrationStackedContent, { isMobile: isMobile }, () => (React.createElement(ProductSelectorContainer, { locale: locale, products: filteredProducts }))));
};
export default ProductSliderIntegration;
